/* Titre de l'onglet quand la visiteuse part sur un autre onglet (demande de Raph, 20/10).
   Deux phrases qui alternent toutes les 2 s ; si le panier contient un article, on parle du panier.
   Le vrai titre revient dès qu'elle revient sur le site. */
(function () {
  var PHRASES = ["💤 Revenez vite…", "☁️ Votre couette vous attend"];
  var PHRASES_PANIER = ["🛒 Votre panier vous attend", "💤 Revenez vite…"];
  var DELAI = 2000;

  var titre = document.title;
  var minuterie = null;
  var absente = false;

  function alterner(phrases) {
    var i = 0;
    document.title = phrases[0];
    minuterie = setInterval(function () {
      i = (i + 1) % phrases.length;
      document.title = phrases[i];
    }, DELAI);
  }

  function partir() {
    absente = true;
    titre = document.title;
    var racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    alterner(PHRASES);
    fetch(racine + "cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (panier) {
        if (!absente || !panier || !panier.item_count) return;
        clearInterval(minuterie);
        alterner(PHRASES_PANIER);
      })
      .catch(function () {});
  }

  function revenir() {
    absente = false;
    clearInterval(minuterie);
    minuterie = null;
    document.title = titre;
  }

  document.addEventListener("visibilitychange", function () {
    if (document.hidden) partir();
    else if (absente) revenir();
  });
})();
